import { getDisputeReason } from '@/services/saas-dispute/allSessions';
import { useEffect, useState } from 'react';

interface Option {
    value: string;
    label: string;
}

export default () => {
    const [disputeReasonLoading, setDisputeReasonLoading] = useState<boolean>(false);
    const [disputeReason, setDisputeReason] = useState<any[]>([]);

    // 获取咨询原因
    const fetchDisputeReason = async () => {
        try {
            setDisputeReasonLoading(true);
            const data = await getDisputeReason();
            setDisputeReason(data);
        } finally {
            setDisputeReasonLoading(false);
        }
    };

    // useEffect(() => {
    //     fetchDisputeReason();
    // }, []);

    return {
        disputeReason,
        setDisputeReason,
        disputeReasonLoading,
        setDisputeReasonLoading
    };
};
